var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIconMonolightEdgeApplicationManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{mask:url(#mask);}.cls-7{fill:#161616;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.868,
    y1: 14.228,
    x2: 22.949,
    y2: 24.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2,
    y1: 15,
    x2: 16.5,
    y2: -3.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.277
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 24,
    x2: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 27,
    y1: 22,
    x2: 27,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,9a6.975,6.975,0,0,0-4.947,2.053l1.413,1.413A5,5,0,1,1,11.1,17H9.08A7,7,0,1,0,16,9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23 24 10 25 6 14 20 14 23 24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,16a11.921,11.921,0,0,1-.9,4.541l1.851.757a13.942,13.942,0,0,0-2.11-14.14L25.416,8.584A11.933,11.933,0,0,1,28,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.416,26.694a11.947,11.947,0,0,1-15.8-4.7l-1.73,1a13.948,13.948,0,0,0,18.561,5.426Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,4a11.952,11.952,0,0,1,3.051.408l.508-1.932A13.946,13.946,0,0,0,2,16H4A12.013,12.013,0,0,1,16,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 17 6 17 10 8 20 6 20 0 0 0 0 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "24 26 24 32 0 32 0 16 6 16 12 26 24 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "25 22 32 22 32 2 22 2 25 22"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Build_icon_here",
    "data-name": "Build icon here"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M24,31a4,4,0,1,1,4-4A4,4,0,0,1,24,31Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,24,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M29,9H22a1,1,0,0,1-.864-1.5l3.5-6a1.041,1.041,0,0,1,1.728,0l3.5,6A1,1,0,0,1,29,9ZM23.741,7h3.518L25.5,3.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8,19H1V12H8ZM3,17H6V14H3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconMonolightEdgeApplicationManager);
export default __webpack_public_path__ + "static/media/app-icon-monolight-EdgeApplicationManager.5d5218d919ff0e9d1d4e531ef6b14c21.svg";
export { ForwardRef as ReactComponent };